module.exports = __webpack_public_path__ + "static/img/pet-02.f8c24f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/album/pet-02.jpg
// module id = wkL8
// module chunks = 0